import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import HeaderLogin from '../../main/nav-login/HeaderLogin';
import Footer from '../../main/nav/Footer';
import Publikasi from '../component/Publikasi';

export default function PublikasiAll() {
    const { state } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [publikasi, setPublikasi] = useState([]);

    const gotoGrafik = () => {
        navigate('/');
    };

    const fetchData = async () => {
        const { data } = await axios.get('/data-get');
        if (data) {
            setData(data);
        }
    };

    const fetchPublikasi = async () => {
        const { data } = await axios.get(`/publikasiall-get/${state}`);
        if (data) {
            setPublikasi(data);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPublikasi();
    }, [state]);

    return (
        <div className="min-h-screen bg-slate-50 text-brand-navy">
            <HeaderLogin data={data} grafik={gotoGrafik} />
            <Publikasi data={publikasi} state={state} />
            <div className="bg-brand-navy text-white">
                <Footer />
            </div>
        </div>
    );
}
